import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import _actions from '../actions';
import { FormFieldWrapper } from '../components/common/FormFieldWrapper';
import './PromoCode.css';

class PromoCodeContainer extends Component {
  render() {
    const {
      actions,
      loading,
      inventory,
      sale: { promoCode },
      config
    } = this.props;

    return (
      <>
        {config.enablePromoCode && (
          <>
            <div className="promo-code">
              <FormFieldWrapper name="promoCode" label="Promo code" type="text">
                <input
                  type="text"
                  className="swformfield__control"
                  value={promoCode || ''}
                  onChange={e =>
                    actions.updateSale({ promoCode: e.target.value })
                  }
                />
              </FormFieldWrapper>

              <div className="swformsubmit">
                <button
                  className="swformback__btn"
                  type="button"
                  disabled={loading || inventory.loading}
                  onClick={() => actions.getPackages()}
                >
                  Apply
                </button>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

PromoCodeContainer.propTypes = {
  actions: PropTypes.object,
  params: PropTypes.object,
  router: PropTypes.object,
  route: PropTypes.object,
  error: PropTypes.string,
  loading: PropTypes.bool,
  sale: PropTypes.object,
  config: PropTypes.object,
  done: PropTypes.bool,
  inventory: PropTypes.object
};

const mapStateToProps = state => ({
  ...state.sale,
  config: state.config,
  inventory: state.inventory
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(_actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PromoCodeContainer));
